// Imports ------------------------------------------------------------------->

import { Component } from "../Component";
import { element } from "../CustomElement";
import { i18n } from "../../i18n/I18n";

import { Dialog } from "../flipp-dialog/Dialog";

import {inject} from "../../services/di";
import {AnalyticsService} from "../../services/AnalyticsService";
import {EventService} from "../../services/EventService";
import {ShoppingListService} from "../../services/ShoppingListService";
import {AuthStatus} from "../../services/definitions/IAuthenticationService";
import {AuthenticationService} from "../../services/AuthenticationService";
import {ConfigService} from "../../services/ConfigService";
import {AuthProvider} from "../../definitions/CommonDefinitions";
import { LinkService } from "../../services/LinkService";
import { BlackFridayService } from "../../services/BlackFridayService";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

@element("flipp-account-trigger-element")
export class AccountTriggerElement extends Component<{}, void> {
	@inject auth: AuthenticationService;
	@inject eventService: EventService;
	@inject analytics: AnalyticsService;
	@inject config: ConfigService;
	@inject bf: BlackFridayService;

	@inject shoppingList: ShoppingListService;

	refs: {
		logoutDialog: Dialog,
		loginButton: HTMLButtonElement,
		closeBtn: HTMLButtonElement,
		formSignInHeader: HTMLElement,
		formSignInText: HTMLElement,
		flippLogo: HTMLDivElement
		changePassword: HTMLElement
	};

	prepare() {
		window.addEventListener("show-modal-form", this.showAuthDialogForm);
	}

	onAttach() {
		window.addEventListener("flipp-auth", this.handleAuthEvent_);
	}

	onDetach() {
		window.removeEventListener("flipp-auth", this.handleAuthEvent_);
		window.removeEventListener("show-modal-form", this.showAuthDialogForm);
	}

	render() {
		const defaultProfile = `https://f.wishabi.net/creative/Distribution/images/icons/account-outline-default5.svg`;
		const defaultProfileBF = `https://f.wishabi.net/creative/Distribution/images/bf/account-outline+1.png`;

		if (this.refs.changePassword && this.auth.user && this.auth.user.info.provider === AuthProvider.EMAIL) {
			this.refs.changePassword.style.display = "block";
		}
		return <div flex-vertical>
			<button class="authenticate"
							ref="loginButton"
							onClick={this.handleSignIn}
							anchor-point="right bottom">
				{this.auth.status === AuthStatus.LOGGED_IN ?
					<div flex-horiztonal>
						{
							this.bf.isOnHost() ?
								<img src={this.auth.user.info.image || defaultProfile} height="20px" onError={`this.src='${defaultProfileBF}'`} alt="" /> :
								<img src={this.auth.user.info.image || defaultProfile} height="20px" onError={`this.src='${defaultProfile}'`} alt="" />
						}
						<span>{this.auth.user.info.name || this.auth.user.info.email}</span>
					</div>
				:
					<div flex-horiztonal>
						{
							this.bf.isOnHost() ?
								<img src={defaultProfileBF} height="20px" alt="" /> :
								<img src={defaultProfile} height="20px" alt="" />
						}
						<span>{i18n("signin")}</span>
					</div>
				}
			</button>
			<Dialog class="logout-dialog" ref="logoutDialog" anchor-point="right top">
				<div class="arrow"></div>
				{this.auth.status === AuthStatus.LOGGED_IN ?
					<div>
						{this.auth.user.info.name ?
							<div class="details" flex-horiztonal>
								<div>{i18n("name")}</div>
								<div>{this.auth.user.info.name}</div>
							</div>
						:
							null
						}
						<div class="details" flex-horiztonal>
							<div>{i18n("email")}</div>
							<div>{this.auth.user.info.email}</div>
						</div>
						<button ref="changePassword" style={{display: "none"}} onClick={this.handleChangePassword}><span>{i18n("change_password")}</span></button>
						<button onClick={this.handleLogout_}><span>{i18n("signout")}</span></button>
					</div>
				: null
				}
			</Dialog>
		</div>;
	}

	private showAuthDialogForm = (e: Event) => {
		this.refs.formSignInHeader.textContent = i18n("signin_title_form");
		this.refs.formSignInText.textContent = i18n("signin_value_form");
		this.refs.flippLogo.classList.add("hidden-logo");
		this.showAuthDialog_(null);
	}

	private handleSignIn = (e: Event) => {
		if (this.auth.status === AuthStatus.LOGGED_IN) {
			this.refs.logoutDialog.showModal(this.refs.loginButton);
		} else {
			e.preventDefault();
			const linkService = LinkService.getInstance();
			linkService.execute("/signin", this);
		}
	}

	private handleChangePassword = (e: Event) => {
		e.preventDefault();
		const linkService = LinkService.getInstance();
		linkService.execute("change_password", this);
	}

	private showAuthDialog_ = (e: Event) => {
		if (this.auth.status === AuthStatus.LOGGED_IN) {
			this.refs.logoutDialog.showModal(this.refs.loginButton);
		}
	}

	private handleLogout_ = () => {
		const provider = this.auth.user.info.provider;
		const userGuid = this.auth.user.token.user_id;
		this.auth.logout(this).then(() => {
			this.analytics.setAccountGuid(null);
			this.eventService.fireAuthEvent("logout", null);
			this.eventService.redirectWhenLogoutInForm();
			this.analytics.trackSignout(userGuid, provider);
		}).catch((e: Error) => {});
		this.eventService.unsubscribeFromRedirect();
	}

	private handleAuthEvent_ = (e: CustomEvent) => {
		if (this.refs.logoutDialog.open) {
			this.refs.logoutDialog.close();
		}
		this.invalidate();
	}
}
